import { WindowOrder } from '@cutr/constants/windows/windows';

import { useWindowStore } from '../../api/windowStore';

export const useResetWindowStore = () => {
  const { reset } = useWindowStore.getState();

  return () => {
    reset();
  };
};

export const useHydrateWindowStore = () => {
  const resetStore = useResetWindowStore();
  const { init } = useWindowStore.getState();

  const hydrateStore = (order: WindowOrder) => {
    resetStore();
    init(order);
  };

  return hydrateStore;
};
